<div class="ucb" *ngIf="data; else loadingTpl">
  <div class="scope-note">
    <p class="text-muted no-margin">
      <span *ngIf="data.businessUnitName">Business unit: <b>{{data.businessUnitName}}</b>. </span>
      Centre bricks are where this user's business trips start (the <b>From</b> of a matrix expense); a user can have several.
    </p>
    <p class="text-muted no-margin" *ngIf="canManage">A centre added below is a direct exception for this user. It applies from its start date; close it with an end date to keep it in the history.</p>
  </div>

  <div class="ucb-alert ucb-unit" *ngIf="data.businessUnitCentres.length">
    <i class="fa fa-sitemap"></i>
    From their business unit (BU Bricks): <b>{{data.businessUnitCentres.join(', ')}}</b>.
  </div>
  <div class="ucb-alert ucb-exception" *ngIf="data.exceptionCentres.length">
    <i class="fa fa-user-plus"></i>
    Granted directly to this user (exception): <b>{{data.exceptionCentres.join(', ')}}</b>.
  </div>
  <div class="ucb-alert ucb-inherit" *ngIf="source === 'Team'">
    <i class="fa fa-users"></i>
    Held through their team: this user has no centre of their own, so the centres of the territories under them are used:
    <b>{{teamText()}}</b>.
  </div>
  <div class="ucb-alert ucb-muted" *ngIf="hasOwn && data.teamCentres.length">
    <i class="fa fa-info-circle"></i>
    Their team's centres are not used because they have their own: {{teamText()}}.
  </div>
  <div class="ucb-alert ucb-none" *ngIf="source === 'None'">
    <i class="fa fa-exclamation-triangle"></i>
    This user has no centre bricks<span *ngIf="data.isManager">, and the territories under them have none either</span>:
    they can't choose a From brick in matrix expenses.
  </div>

  <div class="ucb-add" *ngIf="canManage">
    <select class="form-control" [(ngModel)]="newBrickId" name="newBrick">
      <option [ngValue]="null">{{options.length ? 'Choose a brick' : 'No bricks in their business unit'}}</option>
      <option *ngFor="let o of options" [ngValue]="o.id">{{o.name}}</option>
    </select>
    <input type="date" class="form-control ucb-date" [(ngModel)]="newStart" name="newStart" title="Start date">
    <button type="button" class="btn btn-save" [disabled]="!newBrickId || !newStart || saving" (click)="add()">
      <i class="fa fa-plus"></i> Add centre
    </button>
  </div>

  <table class="table ucb-table">
    <thead>
      <tr><th>Brick</th><th>Start</th><th>End</th><th>Status</th><th *ngIf="canManage"></th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let l of openLinks">
        <td><b>{{l.brickName}}</b></td>
        <td>{{l.startDate | date:'dd/MM/yyyy'}}</td>
        <td>
          <ng-container *ngIf="closing?.id !== l.id">{{l.endDate ? (l.endDate | date:'dd/MM/yyyy') : '—'}}</ng-container>
          <span class="ucb-close-edit" *ngIf="closing?.id === l.id">
            <input type="date" class="form-control ucb-date" [(ngModel)]="closeDate" name="closeDate">
            <button type="button" class="btn btn-xs btn-save" [disabled]="!closeDate || saving" (click)="saveClose()">Save</button>
            <a href="javascript:;" (click)="closing = null">Cancel</a>
          </span>
        </td>
        <td><span class="ucb-badge" [class.ucb-upcoming]="isUpcoming(l)" [class.ucb-ending]="!isUpcoming(l) && l.endDate">{{isUpcoming(l) ? 'Upcoming' : (l.endDate ? 'Ending' : 'Open')}}</span></td>
        <td *ngIf="canManage" class="ucb-actions">
          <a href="javascript:;" *ngIf="closing?.id !== l.id" (click)="startClose(l)" title="Close with an end date (kept in the history)"><i class="fa fa-calendar-times-o"></i> Close</a>
          <a href="javascript:;" (click)="remove(l)" title="Delete (added by mistake)"><i class="fa fa-trash-o"></i></a>
        </td>
      </tr>
      <tr *ngIf="!openLinks.length"><td [attr.colspan]="canManage ? 5 : 4" class="text-muted">No open centre bricks set on this user.</td></tr>
      <tr class="ucb-history-head" *ngIf="closedLinks.length"><td [attr.colspan]="canManage ? 5 : 4">History</td></tr>
      <tr *ngFor="let l of closedLinks" class="ucb-closed">
        <td>{{l.brickName}}</td>
        <td>{{l.startDate | date:'dd/MM/yyyy'}}</td>
        <td>{{l.endDate | date:'dd/MM/yyyy'}}</td>
        <td><span class="ucb-badge ucb-badge-closed">Closed</span></td>
        <td *ngIf="canManage" class="ucb-actions">
          <a href="javascript:;" (click)="remove(l)" title="Delete"><i class="fa fa-trash-o"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #loadingTpl>
  <div class="text-center"><i class="fa fa-spinner fa-spin" style="font-size:32px;color:darkseagreen"></i></div>
</ng-template>
